import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const ADMIN_PUBLIC_AUTH_KEYS_QUERY_KEY = 'adminPublicAuthKeys';

export function useGetAdminPublicAuthKeys({
	enabled,
	refetchOnWindowFocus = false,
	accountID,
	meta,
}: {
	enabled: boolean;
	refetchOnWindowFocus?: boolean;
	accountID: string;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		refetchOnWindowFocus,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAPIKeyReference[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: { account: { id: accountID } } as Api.IImpersonationContext,
					urlPath: `public/auth/key`,
				}),
				'GET'
			);
		},
		queryKey: [ADMIN_PUBLIC_AUTH_KEYS_QUERY_KEY, accountID],
		meta,
	});
}

export const invalidateGetAdminPublicAuthKeys = ({ accountID }: { accountID: string }) =>
	reactQueryClient.invalidateQueries({ queryKey: [ADMIN_PUBLIC_AUTH_KEYS_QUERY_KEY, accountID] });
